import { render, staticRenderFns } from "./SupplierOnboardingHomePage.vue?vue&type=template&id=5fa945f6&"
import script from "./SupplierOnboardingHomePage.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingHomePage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingHomePage.vue?vue&type=style&index=0&id=5fa945f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports